import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import { Alert, SxProps, Theme } from '@mui/material';
import useScenarioMode from '../../hooks/useScenarioMode';

interface ScenarioModeAlertProps {
  sx?: SxProps<Theme>;
}

const ScenarioModeAlert = ({ sx }: ScenarioModeAlertProps) => {
  const { isScenarioActive, scenarioName } = useScenarioMode();

  if (!isScenarioActive) return null;

  return (
    <Alert
      severity='warning'
      icon={<ScienceOutlinedIcon fontSize='small' />}
      sx={{ mb: 2, ...sx }}
    >
      <strong>Scenario mode: {scenarioName}</strong> — changes here affect
      scenario data only, not production.
    </Alert>
  );
};

export default ScenarioModeAlert;
